<template>
  <footer class="site-footer column-gap-8">
    <div>Copyright California ISO {{ thisYear() }} - All Rights Reserved</div>
    <a href="https://www.caiso.com/privacy-terms-of-use">Privacy and Terms of use</a>
  </footer>
</template>

<script setup>
import { thisYear } from '@shared/utils/date'
</script>
